// extracted by mini-css-extract-plugin
module.exports = {"headerPadding":"style_headerPadding__2sTmp","subHeaderWrapper":"style_subHeaderWrapper__2h5__"};